import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from 'components/core';
import * as Pages from './pages/index';
import { ROUTE_PREFIX } from 'configs/constants';
import * as Sentry from '@sentry/react';

export const RouteManager = () => {
  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
  
return (
    <SentryRoutes>
      <Route path={`${ROUTE_PREFIX}/qs/:quickshopid`} element={<PrivateRoute component={Pages.Main} />} />
      <Route path={`${ROUTE_PREFIX}/pstat/:possessionid`} element={<PrivateRoute component={Pages.POSSession} />} />
      <Route path={`${ROUTE_PREFIX}/rental/:quickshopid`} element={<PrivateRoute component={Pages.Rental} />} />
      <Route path="*" element={<PrivateRoute component={Pages.NotFound} />} />
    </SentryRoutes>
  );
};

export default RouteManager;
